import React, { Component } from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import { Input } from './Input';

import { statisticFilterCreate } from '../actions/elements';

const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  > input {
    width: auto;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  > div {
    flex-basis: 49%;
    margin: 5px auto;
  }

  > button {
    margin: 20px 0;
  }
`;

export class StatisticModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      measurements_report: false,
      elements_with_measurements: false,
      date_start: '',
      date_end: '',
      location: '',
      street: '',
      rl_min: '',
      rl_max: '',
      ql_min: '',
      ql_max: '',
      rw_min: '',
      rw_max: '',
      srt_min: '',
      srt_max: '',
      material_type: '',
      position: '',
      grit_beads: '',
      line: '',
    };
    this.handleWithmeasurementsChange = this.handleWithmeasurementsChange.bind(this);
    this.handleDatestartChange = this.handleDatestartChange.bind(this);
    this.handleDateendChange = this.handleDateendChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleStreetChange = this.handleStreetChange.bind(this);
    this.handleRlminChange = this.handleRlminChange.bind(this);
    this.handleRlmaxChange = this.handleRlmaxChange.bind(this);
    this.handleQlminChange = this.handleQlminChange.bind(this);
    this.handleQlmaxChange = this.handleQlmaxChange.bind(this);
    this.handleRwminChange = this.handleRwminChange.bind(this);
    this.handleRwmaxChange = this.handleRwmaxChange.bind(this);
    this.handleSrtminChange = this.handleSrtminChange.bind(this);
    this.handleSrtmaxChange = this.handleSrtmaxChange.bind(this);
    this.handleMaterialtypeChange = this.handleMaterialtypeChange.bind(this);
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleGritbeadsChange = this.handleGritbeadsChange.bind(this);
    this.handleLineChange = this.handleLineChange.bind(this);
    this.handleFromFormStatistic = this.handleFromFormStatistic.bind(this);
    this.handleFromFilterStatistic = this.handleFromFilterStatistic.bind(this);
  }

  handleWithmeasurementsChange(e) {
    if (e.target.id === 'elements_with_measurements') {
      this.setState({
        elements_with_measurements: true,
        measurements_report: false,
      });
    } else if (e.target.id === 'measurements_report') {
      this.setState({
        measurements_report: true,
        elements_with_measurements: false,
      });
    } else {
      this.setState({
        elements_with_measurements: false,
        measurements_report: false,
      });

    }
  }

  handleDatestartChange(e) {
    this.setState({date_start: e.target.value});
  }

  handleDateendChange(e) {
    this.setState({date_end: e.target.value});
  }

  handleLocationChange(e) {
    this.setState({location: e.target.value});
  }

  handleStreetChange(e) {
    this.setState({street: e.target.value});
  }

  handleRlminChange(e) {
    this.setState({rl_min: e.target.value});
  }

  handleRlmaxChange(e) {
    this.setState({rl_max: e.target.value});
  }

  handleQlminChange(e) {
    this.setState({ql_min: e.target.value});
  }

  handleQlmaxChange(e) {
    this.setState({ql_max: e.target.value});
  }

  handleRwminChange(e) {
    this.setState({rw_min: e.target.value});
  }

  handleRwmaxChange(e) {
    this.setState({rw_max: e.target.value});
  }

  handleSrtminChange(e) {
    this.setState({srt_min: e.target.value});
  }

  handleSrtmaxChange(e) {
    this.setState({srt_max: e.target.value});
  }

  handleMaterialtypeChange(e) {
    this.setState({material_type: e.target.value});
  }

  handlePositionChange(e) {
    this.setState({position: e.target.value});
  }

  handleGritbeadsChange(e) {
    this.setState({grit_beads: e.target.value});
  }

  handleLineChange(e) {
    this.setState({line: e.target.value});
  }

  handleFromFormStatistic() {
    statisticFilterCreate(this.state);
  }

  handleFromFilterStatistic() {
    statisticFilterCreate({
      measurements_report: this.state.measurements_report,// eslint-disable-line
      elements_with_measurements: this.state.elements_with_measurements,// eslint-disable-line
      element_ids: this.props.elemntIds, // eslint-disable-line
    });
  }

  render() {
    const {
      measurements_report,
      elements_with_measurements,
      date_start,
      date_end,
      location,
      street,
      rl_min,
      rl_max,
      ql_min,
      ql_max,
      rw_min,
      rw_max,
      // srt_min,
      // srt_max,
      material_type,
      position,
      grit_beads,
      line,
    } = this.state;

    return (
      <div>
        <CheckboxWrapper>
          <input
            id="measurements_off"
            name="radio-measurements"
            onChange={this.handleWithmeasurementsChange}
            type="radio"
            value={!measurements_report && !elements_with_measurements}
            checked={!measurements_report && !elements_with_measurements}
          />
          <label htmlFor="measurements_off">
            Only elements
          </label>
          <input
            id="measurements_report"
            name="radio-measurements"
            onChange={this.handleWithmeasurementsChange}
            type="radio"
            value={measurements_report}
            checked={measurements_report}
          />
          <label htmlFor="measurements_report">
            Only measurements
          </label>
          <input
            id="elements_with_measurements"
            name="radio-measurements"
            onChange={this.handleWithmeasurementsChange}
            type="radio"
            value={elements_with_measurements}
            checked={elements_with_measurements}
          />
          <label htmlFor="elements_with_measurements">
            Elements with measurements
          </label>
        </CheckboxWrapper>
        <InputWrapper>
          <Input
            onChange={this.handleDatestartChange}
            placeholder="Date Start"
            type="date"
            value={date_start}
          />
          <Input
            onChange={this.handleDateendChange}
            placeholder="Date End"
            type="date"
            value={date_end}
          />
          <Input
            onChange={this.handleLocationChange}
            placeholder="Location"
            type="text"
            value={location}
          />
          <Input
            onChange={this.handleStreetChange}
            placeholder="Street"
            type="text"
            value={street}
          />
          <Input
            onChange={this.handleRlminChange}
            placeholder="RL Min"
            type="number"
            value={rl_min}
          />
          <Input
            onChange={this.handleRlmaxChange}
            placeholder="RL Max"
            type="number"
            value={rl_max}
          />
          <Input
            onChange={this.handleQlminChange}
            placeholder="Qd Min"
            type="number"
            value={ql_min}
          />
          <Input
            onChange={this.handleQlmaxChange}
            placeholder="Qd Max"
            type="number"
            value={ql_max}
          />
          <Input
            onChange={this.handleRwminChange}
            placeholder="RW Min"
            type="number"
            value={rw_min}
          />
          <Input
            onChange={this.handleRwmaxChange}
            placeholder="RW Max"
            type="number"
            value={rw_max}
          />
          {/* <Input
            onChange={this.handleSrtminChange}
            placeholder="srtmin"
            type="number"
            value={srt_min}
          />
          <Input
            onChange={this.handleSrtmaxChange}
            placeholder="srtmax"
            type="number"
            value={srt_max}
          /> */}
          <Input
            onChange={this.handleMaterialtypeChange}
            placeholder="Material Type"
            type="text"
            value={material_type}
          />
          <Input
            onChange={this.handlePositionChange}
            placeholder="Position"
            type="text"
            value={position}
          />
          <Input
            onChange={this.handleGritbeadsChange}
            placeholder="Grit Beads"
            type="text"
            value={grit_beads}
          />
          <Input
            onChange={this.handleLineChange}
            placeholder="Line"
            type="text"
            value={line}
          />
        </InputWrapper>
        <div style={{display: 'flex', justifyContent: 'space-between', margin: '20px 0 10px'}}>
          <Button onClick={this.handleFromFormStatistic}>
            Generate from form
          </Button>
          <Button onClick={this.handleFromFilterStatistic}>
            Generate from filtered elements
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatisticModal.js